export const Medication = 
{
    Metadata:{Name:'Medication',maxColumn:5,numRows:87},
    Sections:
    [
        {
            Headers:[
                "SSRI",
                "Have you ever taken",
                "Was it helpful?",
                "Side Effects",
                "Comments/Concerns",
            ],
            Questions:[
                {
                    Prompt:"Fluoxetine (Prozac)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Paroxetine (Paxil)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Sertraline (Zoloft)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Citalopram (Celexa)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Escitalopram (Lexapro)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Fluvoxamine (Luvox)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
            ]
        },
        {
            Headers:[
                "SNRI",
                "Have you ever taken",
                "Was it helpful?",
                "Side Effects",
                "Comments/Concerns",
            ],
            Questions:[
                {
                    Prompt:"Duloxetine (Cymbalta)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Venlafaxine (Effexor)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Desvenlafaxine (Pristiq)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Milnacipram (Savella)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Levomilnacipram (Fetzima)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
            ]
        },
        {
            Headers:[
                "Other",
                "Have you ever taken",
                "Was it helpful?",
                "Side Effects",
                "Comments/Concerns",
            ],
            Questions:[
                {
                    Prompt:"Vilazodone (Viibryd)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Vorteoxetine (Brintellix)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Bupropion (Wellbutrin)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Mirtazapine (Remeron)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Nefazodone (Serzone)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Trazodone (Desyrel)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Agomelatine (Valdoxan)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
            ]
        },
        {
            Headers:[
                "TCA",
                "Have you ever taken",
                "Was it helpful?",
                "Side Effects",
                "Comments/Concerns",
            ],
            Questions:[
                {
                    Prompt:"Clomipramine (Anafranil)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Imipramine (Tofranil)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Amitriptyline (Elavil)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Desipramine (Noripramin)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Nortriptyline (Pamelor)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Trimipramine (Surmontil)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Amoxapine (Asendin)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Maprotiline (Ludiomil)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Doxepin (Sinequan)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Protriptyline (Vivactil)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
            ]
        },
        {
            Headers:[
                "MAOI",
                "Have you ever taken",
                "Was it helpful?",
                "Side Effects",
                "Comments/Concerns",
            ],
            Questions:[
                {
                    Prompt:"Phenelzine (Nardil)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Tranylcypromine (Parnate)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Isocarboxazid (Marplan)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Selegiline (Emsam patch)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
            ]
        },
        {
            Headers:[
                "Antipsychotics",
                "Have you ever taken",
                "Was it helpful?",
                "Side Effects",
                "Comments/Concerns",
            ],
            Questions:[
                {
                    Prompt:"Aripiprazole (Abilify)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Quetiapine (Seroquel)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Olanzapine (Zyprexa)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Risperidone (Risperdal)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Paliperidone (Invega)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Ziprasidone (Geodon)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Clozapine (Clozaril)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Asanapine (Saphris)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Lurasidone (Latuda)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Haloperidol (Haldol)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Thioridazine (Mellaril)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Chlorpromazine-Thorazine",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Perphenazine (Trilafon)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Trifluoperazine (Stelazine)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
            ]
        },
        {
            Headers:[
                "Stabilizers",
                "Have you ever taken",
                "Was it helpful?",
                "Side Effects",
                "Comments/Concerns",
            ],
            Questions:[
                {
                    Prompt:"Lithium salts (Lithium)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Valproic acid / Depakote",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Lamotrigine (Lamictal)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Carbamazepine (Tegretol)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Oxcarbazepine (Trileptal)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
            ]
        },
        {
            Headers:[
                "Stimulants",
                "Have you ever taken",
                "Was it helpful?",
                "Side Effects",
                "Comments/Concerns",
            ],
            Questions:[
                {
                    Prompt:"Amphetamines (Adderall)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Dexamphetamine-Dexedrine",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Dexmethylphenidate-Focalin",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Lisdexamfetamine-Vyvanse",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Ritalin/concerta",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Modafinil (Provigil)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Armodafinil (Nuvigil)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Atomoxetine (Strattera)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
            ]
        },
        {
            Headers:[
                "Other Agents",
                "Have you ever taken",
                "Was it helpful?",
                "Side Effects",
                "Comments/Concerns",
            ],
            Questions:[
                {
                    Prompt:"Buspirone (Buspar)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Liothyronine (Cytomel)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Gabapentin (Neurontin)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Pramipexole (Mirapex)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Omega 3 (Fish oil)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Methylfolate (Deplin)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Folate – Folic acid",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Topiramate (Topomax)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"SAMe",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Roprinole (Requip)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Inositol",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Varenicline (Chantix)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
            ]
        },
        {
            Headers:[
                "Benzodiazepines",
                "Have you ever taken",
                "Was it helpful?",
                "Side Effects",
                "Comments/Concerns",
            ],
            Questions:[
                {
                    Prompt:"Clonazepam (Klonopin)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Alprazolam (Xanax)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Lorazepam (Ativan)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Diazepam (Valium)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Temazepam (Restoril)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Oxazepam (Serax)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Chlordiazepoxide (Librium)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
            ]
        },
        {
            Headers:[
                "",
                "Have you ever taken",
                "Was it helpful?",
                "Side Effects",
                "Comments/Concerns",
            ],
            Questions:[
                {
                    Prompt:"Psychotherapy (EMDR)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Psychotherapy (DBT)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Psychotherapy (ABA)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Psychotherapy (DOJ approved therapies)",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Counseling",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Chemical Dependency Treatment",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Psychiatric Hospitalization",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
                {
                    Prompt:"Light therapy",
                    Responses:[
                        {Value:"taken",Type:"checkbox"},
                        {Value:"helpful",Type:"checkbox"},
                        {Value:"side",Type:"checkbox"},
                        {Value:"Comments/Concerns",Type:"text"},
                    ]
                },
            ]
        },
    ]
}